function Loading({ className = "spinner-border m-3" }) {
  return (
    <div className="d-flex align-items-center justify-content-center">
      <div className={className} role="status">
        <span className="visually-hidden">Loading...</span>
      </div>
    </div>
  );
}

export default Loading;
